<template>
  <label class="bbp-checkbox">
    <input class="bbp-checkbox__input"
           type="checkbox"
           v-model="value"
           :disabled="disable"
    >
    <span class="bbp-checkbox__checkmark"/>
    <span
      v-if="title"
      class="bbp-checkbox__title"
      :class="{'bbp-checkbox__title_disabled': disable}"
    >
      {{title}}
    </span>
  </label>
</template>

<script>
export default {
  name: 'BBPCheckbox',
  props: ['title', 'item', 'defaultValue', 'disable'],
  data () {
    return {
      value: this.defaultValue
    }
  },
  methods: {
    setValue (val) {
      this.value = val
    }
  },
  watch: {
    value () {
      this.$emit('change', {value: this.value, item: this.item})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-checkbox {
    display: inline-flex;
    align-items: center;
    user-select: none;
    position: relative;
    cursor: pointer;
    transition: 0.3s;

      &:hover {
        opacity: 0.8;
      }

      &__input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;

        &:checked + .bbp-checkbox__checkmark {
          &:after {
            font-size: 15px;
            opacity: 1;
            background-color: $color-accent;
          }
        }

        &:disabled + .bbp-checkbox__checkmark {
          border: 1px solid $color-gray;

          &:after {
            background-color: rgba($color-wild-sand,0.5);
            color: $color-gray;
          }
        }
      }

      &__checkmark {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;
        border: 1px solid $color-accent;
        box-sizing: border-box;
        border-radius: 2px;

        &:after {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "bb-projects", serif;
          content: '\E815';
          position: absolute;
          color: $color-white;
          background-color: $color-white;
          border-radius: 2px;
          width: 15px;
          height: 15px;
          font-size: 0;
          opacity: 0;
          transition: 0.3s;
        }
      }

      &__title {
        font-weight: normal;
        font-size: 14px;
        line-height: 1;
        margin-left: 9px;

        &_disabled {
          color: $color-gray;
        }
      }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/InputFields/BBPCheckbox/BBPCheckbox.vue